import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import DoubleTranslatedCustomRichText from '@/components/CustomRichText/DoubleTranslatedCustomRichText';import AccordionPanel from '@/components/UI/AccordionPanel/AccordionPanel';
import InfoMsg from '@/components/UI/InfoMsg/InfoMsg';
import Spinner from '@/components/UI/Spinner/Spinner';
import * as Constants from '@/helpers/constants';
import { LANGUAGES_ABBREVIATION } from '@/helpers/constants';
import { getEditorId, removeParagraphTags, tabLowerCase } from '@/helpers/utils';
import useToastContext from '@/hooks/useToastContext';
import { setHelpTranslations } from '@/redux/Help/help.action';
import { getHelpTranslations } from '@/redux/Help/help.reducer';
import administrationServices from '@/services/administrationServices';
import { ReduxHelp } from '@/types';
import styles from '../HelpText.module.scss';

interface TranslationsHelpTextProps {
  helpTranslations: ReduxHelp;
  setTranslations: (help: ReduxHelp) => void;
}

const TranslationsHelpText: React.FC<TranslationsHelpTextProps> = (props) => {
  const { t } = useTranslation();
  const tab = tabLowerCase(window.location.pathname.split('/')[4]);
  const [originalValues, setOriginalValues] = useState({});
  const { helpTranslations, setTranslations } = props;
  const isLoading = helpTranslations && !helpTranslations.TRANSLATIONS_TAB;
  const { addToast } = useToastContext();
  const TRANSLATIONS_TAB = 'TRANSLATIONS_TAB';
  const TRANSLATIONS_TRANSLATIONS = 'TRANSLATIONS_TRANSLATIONS';

  const ID_GENERAL_TRANSLATIONS = 'general-translations';
  const ID_TRANSLATIONS_TRANSLATIONS = 'translations-translations';

  useEffect(() => {
    administrationServices.getHelp(tab)
      .then((data) => {
        setTranslations(data);
        setOriginalValues(data);
      })
      .catch((error) => addToast(error.message, 'ERROR'));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleWysiwygChange = (lang, label, data) => {
    const propValues = { ...helpTranslations[label] };
    const isModified = removeParagraphTags(data) !== removeParagraphTags(originalValues[label][lang]);
    const newState = {
      ...helpTranslations,
      [label]: {
        ...propValues,
        [lang]: data,
      },
      modified: isModified,
    };

    if (isModified) {
      setTranslations(newState as unknown as ReduxHelp);
      setOriginalValues(newState);
    }
  };

  return (
    <>
      {isLoading && <Spinner isVisible isMask />}
      {!isLoading && (
        <>
          <InfoMsg msg={t('administration.helpText.info')} />
          <AccordionPanel
            title={t('administration.helpText.generalText')}
          >
            <DoubleTranslatedCustomRichText
              id={ID_GENERAL_TRANSLATIONS}
              title={t('helptext')}
              initialValue={helpTranslations?.TRANSLATIONS_TAB}
              handleInputChange={(lang, newValue) => handleWysiwygChange(lang, TRANSLATIONS_TAB, newValue)}
            />
          </AccordionPanel>
          <AccordionPanel
            title={`${t('campaignRequests.title')}: ${t('translations.title')}`}
          >
            <DoubleTranslatedCustomRichText
              id={ID_TRANSLATIONS_TRANSLATIONS}
              title={t('helptext')}
              initialValue={helpTranslations?.TRANSLATIONS_TRANSLATIONS}
              handleInputChange={(lang, newValue) => handleWysiwygChange(lang, TRANSLATIONS_TRANSLATIONS, newValue)}
            />
          </AccordionPanel>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  helpTranslations: getHelpTranslations(state),
});

const actionCreators = {
  setTranslations: setHelpTranslations,
};

export default connect(mapStateToProps, actionCreators)(TranslationsHelpText);
